import io from 'socket.io-client';

class WebSocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.listeners = new Map();
    // สำหรับเก็บ listeners หลายตัวสำหรับแต่ละ event type
    this.multipleListeners = {
      breakEvent: [],
      workEvent: [],
      userEvent: [],
      notification: [],
      message: [],
      caseEvent: []
    };
  }

  // เชื่อมต่อกับ Backend
  connect() {
    if (this.socket && this.isConnected) {
      return;
    }

    const serverUrl = process.env.REACT_APP_DOMAIN || 'http://localhost:3001';
    
    this.socket = io(serverUrl, {
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    // Event listeners
    this.socket.on('connect', () => {
      this.isConnected = true;
      
      try {
                  // ส่งข้อมูลผู้ใช้ (ต้องส่งทุกครั้งที่เชื่อมต่อ)
          const userId = sessionStorage.getItem('id');
          const userName = sessionStorage.getItem('userName');
        
        if (userId && userName && userId !== 'null' && userName !== 'null') {
          const parsedUserId = parseInt(userId);
          if (!isNaN(parsedUserId)) {
            this.socket.emit('user:join', {
              userId: parsedUserId,
              username: userName
            });
            
            // เมื่อ reconnect แล้วให้ refresh status
            this.refreshUserStatus();
          } else {

          }
                  }
        } catch (error) {
          // Silent error handling
        }
    });

    this.socket.on('disconnect', () => {
      this.isConnected = false;
    });

    this.socket.on('connect_error', (error) => {
      // Silent error handling
    });

    // รับข้อความแจ้งเตือน
    this.socket.on('notification:receive', (data) => {
      this.handleNotification(data);
    });

    // รับข้อความจากผู้ใช้อื่น
    this.socket.on('message:receive', (data) => {
      this.handleMessage(data);
    });

    // รับแจ้งเตือนเมื่อมีคนเข้า-ออก
    this.socket.on('user:joined', (data) => {
      this.handleUserJoined(data);
    });

    this.socket.on('user:left', (data) => {
      this.handleUserLeft(data);
    });

    // รับแจ้งเตือนเมื่อมีคนเริ่มพัก
    this.socket.on('break:started', (data) => {
      this.handleBreakStarted(data);
    });

    // รับแจ้งเตือนเมื่อมีคนจบพัก
    this.socket.on('break:ended', (data) => {
      this.handleBreakEnded(data);
    });

    // รับแจ้งเตือนเมื่อมีคนเข้างาน
    this.socket.on('work:checkin', (data) => {
      this.handleWorkCheckin(data);
    });

    // รับแจ้งเตือนเมื่อมีคนออกงาน
    this.socket.on('work:checkout', (data) => {
      this.handleWorkCheckout(data);
    });

    // รับแจ้งเตือนเมื่อมีเคสเปลี่ยน (สร้าง/หยิบ/เริ่ม/เสร็จ/reject/pending) → realtime
    this.socket.on('case:updated', (data) => {
      this.handleCaseEvent(data);
    });
  }

  // ตัดการเชื่อมต่อ
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  // ส่งข้อความ (สำหรับใช้จาก Frontend)
  sendMessage(message) {
    if (this.socket && this.isConnected) {
      this.socket.emit('message:send', { message });
    }
  }

  // ลงทะเบียน listener สำหรับรับ notification
  onNotification(callback) {
    this.listeners.set('notification', callback);
    this.multipleListeners.notification.push(callback);
  }

  // ยกเลิก listener notification (ใช้ตอน cleanup กัน listener ซ้ำ)
  offNotification(callback) {
    this.multipleListeners.notification = this.multipleListeners.notification.filter(
      (cb) => cb !== callback
    );
  }

  // ลงทะเบียน listener สำหรับรับ message
  onMessage(callback) {
    this.listeners.set('message', callback);
    this.multipleListeners.message.push(callback);
  }

  // ลงทะเบียน listener สำหรับ user events
  onUserEvent(callback) {
    this.listeners.set('userEvent', callback);
    this.multipleListeners.userEvent.push(callback);
  }

  // ลงทะเบียน listener สำหรับ break events
  onBreakEvent(callback) {
    this.listeners.set('breakEvent', callback);
    this.multipleListeners.breakEvent.push(callback);
  }

  // ลงทะเบียน listener สำหรับ work events
  onWorkEvent(callback) {
    this.listeners.set('workEvent', callback);
    this.multipleListeners.workEvent.push(callback);
  }

  // ลงทะเบียน listener สำหรับ case events (realtime case list/badge)
  onCaseEvent(callback) {
    this.multipleListeners.caseEvent.push(callback);
  }

  // ยกเลิก listener case event (ใช้ตอน cleanup กัน listener ซ้ำ)
  offCaseEvent(callback) {
    this.multipleListeners.caseEvent = this.multipleListeners.caseEvent.filter(
      (cb) => cb !== callback
    );
  }

  // จัดการ notification ที่ได้รับ
  handleNotification(data) {
    this.multipleListeners.notification.forEach(callback => {
      if (callback) callback(data);
    });
  }

  // จัดการ message ที่ได้รับ
  handleMessage(data) {
    this.multipleListeners.message.forEach(callback => {
      if (callback) callback(data);
    });
  }

  // จัดการเหตุการณ์ผู้ใช้เข้า
  handleUserJoined(data) {
    this.multipleListeners.userEvent.forEach(callback => {
      if (callback) callback({ type: 'joined', ...data });
    });
  }

  // จัดการเหตุการณ์ผู้ใช้ออก
  handleUserLeft(data) {
    this.multipleListeners.userEvent.forEach(callback => {
      if (callback) callback({ type: 'left', ...data });
    });
  }

  // จัดการเหตุการณ์เริ่มพัก
  handleBreakStarted(data) {
    this.multipleListeners.breakEvent.forEach(callback => {
      if (callback) callback({ type: 'started', ...data });
    });
  }

  // จัดการเหตุการณ์จบพัก
  handleBreakEnded(data) {
    this.multipleListeners.breakEvent.forEach(callback => {
      if (callback) callback({ type: 'ended', ...data });
    });
  }

  // จัดการเหตุการณ์เข้างาน
  handleWorkCheckin(data) {
    this.multipleListeners.workEvent.forEach(callback => {
      if (callback) callback({ type: 'checkin', ...data });
    });
  }

  // จัดการเหตุการณ์ออกงาน
  handleWorkCheckout(data) {
    this.multipleListeners.workEvent.forEach(callback => {
      if (callback) callback({ type: 'checkout', ...data });
    });
  }

  // จัดการเหตุการณ์เคสเปลี่ยน
  handleCaseEvent(data) {
    this.multipleListeners.caseEvent.forEach(callback => {
      if (callback) callback(data);
    });
  }

  // ตรวจสอบสถานะการเชื่อมต่อ
  getConnectionStatus() {
    return {
      isConnected: this.isConnected,
      socketId: this.socket?.id || null
    };
  }

  // เรียกใช้เมื่อ reconnect เพื่อ refresh status (ลดการเรียก API)
  async refreshUserStatus() {
    try {
      const userId = sessionStorage.getItem('id');
      if (!userId) return;
      
      // เรียก API เฉพาะเมื่อจำเป็น (debounce)
      const now = Date.now();
      const lastRefresh = this.lastRefreshTime || 0;
      
      // เรียก API เฉพาะเมื่อผ่านไป 30 วินาทีแล้ว
      if (now - lastRefresh > 30000) {
        this.lastRefreshTime = now;
        
        const response = await fetch(`${process.env.REACT_APP_DOMAIN}/api/v1/websocket/work/status/${userId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        
        if (response.ok) {
          const data = await response.json();
          
          // แจ้งให้ components อื่นๆ รู้ว่า status อัพเดท
          const callback = this.listeners.get('statusUpdate');
          if (callback) {
            callback({ 
              type: 'refresh', 
              userId: userId,
              status: data.data.status,
              message: 'รีเฟรชสถานะเรียบร้อย'
            });
          }
        }
      }
    } catch (error) {
      // Silent error handling
    }
  }
}

// สร้าง instance เดียว (Singleton)
const websocketService = new WebSocketService();

export default websocketService; 